module.exports = __webpack_public_path__ + "static/media/04-galeria-04-cantina-palacio-mobile@2x.65fed045.jpg";